import { Theme } from '@mui/material';
import { globalClasses } from 'core/common/constants/global-classes';
import { pointerHoverMediaQuery, SeasonSansFontFamily } from '../constants';

export const getTextFieldOptions = ({ palette }: Theme) => {
  const textFieldComponents = {
    styleOverrides: {
      root: ({
        ownerState,
      }: {
        ownerState: {
          error?: boolean;
          size?: 'small' | 'medium';
        };
      }) => {
        const baseStyles = {
          [`& ${globalClasses.textFieldRoot}`]: {
            borderRadius: '100px',
            backgroundColor: palette.contentBlockBackground.secondary,
            transition: 'all 0.2s ease-in-out',

            ...(ownerState.size === 'medium' && {
              height: '50px',
            }),

            [`& ${globalClasses.inputBase}`]: {
              paddingRight: '16px',
              paddingLeft: '16px',
              fontFamily: SeasonSansFontFamily,

              '&::placeholder': {
                color: palette.text.secondary,
                opacity: 1,
              },
            },

            [`& ${globalClasses.textFieldFieldset}`]: {
              borderColor: 'transparent',
              borderWidth: '1px',
            },
            [pointerHoverMediaQuery]: {
              [`&:hover ${globalClasses.textFieldFieldset}`]: {
                borderColor: palette.input.mainHover,
              },
            },
            [`&${globalClasses.focused} ${globalClasses.textFieldFieldset}`]: {
              borderColor: palette.input.mainFocus,
              borderWidth: '2px',
            },

            ...(ownerState.error && {
              [`& ${globalClasses.textFieldFieldset}`]: {
                borderColor: palette.error.main,
              },
              [pointerHoverMediaQuery]: {
                [`&:hover ${globalClasses.textFieldFieldset}`]: {
                  borderColor: palette.error.main,
                },
              },
              [`&${globalClasses.focused} ${globalClasses.textFieldFieldset}`]: {
                borderColor: palette.error.main,
              },
            }),

            [`&${globalClasses.disabled}`]: {
              [`& ${globalClasses.textFieldFieldset}`]: {
                borderColor: palette.textField.borderDisabled,
              },
            },
          },
        };

        return {
          ...baseStyles,
        };
      },
    },
    defaultProps: {
      variant: 'outlined',
      size: 'medium',
    },
  };

  return { textFieldComponents };
};
